<nb-card class="sync-dialog">
  <nb-card-header>
    <h4>{{ "dialogs.cloudSync.title" | translate }}</h4>
  </nb-card-header>

  <nb-card-body>

    <!-- Step 1: Provider selection -->
    <ng-container *ngIf="step === 'provider'">
      <div *ngIf="loadingProviders" class="loading-state">
        <nb-spinner status="primary" size="medium"></nb-spinner>
      </div>

      <ng-container *ngIf="!loadingProviders">
        <p class="info-text" *ngIf="connectedProviders.length === 0">
          {{ "dialogs.cloudSync.noProviders" | translate }}
        </p>
        <div class="provider-list" *ngIf="connectedProviders.length > 0">
          <p class="section-label">{{ "dialogs.cloudSync.selectProvider" | translate }}</p>
          <button
            *ngFor="let p of connectedProviders"
            nbButton
            appearance="outline"
            class="provider-btn"
            (click)="selectProvider(p.provider)"
          >
            <nb-icon icon="cloud-outline"></nb-icon>
            {{ p.provider | titlecase }}
            <span class="provider-email" *ngIf="p.account_email">({{ p.account_email }})</span>
          </button>
        </div>
      </ng-container>
    </ng-container>

    <!-- Step 2: Browse -->
    <ng-container *ngIf="step === 'browse'">
      <!-- Breadcrumb -->
      <div class="breadcrumb">
        <button nbButton ghost size="tiny" (click)="navigateTo(-1)">
          {{ providerLabel }}
        </button>
        <ng-container *ngFor="let crumb of breadcrumb; let i = index">
          <nb-icon icon="chevron-right-outline" class="sep"></nb-icon>
          <button nbButton ghost size="tiny" (click)="navigateTo(i)">{{ crumb.name }}</button>
        </ng-container>
      </div>

      <!-- Item list -->
      <div *ngIf="loadingItems" class="loading-state">
        <nb-spinner status="primary" size="small"></nb-spinner>
      </div>

      <div *ngIf="!loadingItems" class="item-list">
        <div
          *ngFor="let item of browseItems"
          class="item-row"
          [class.selected]="isSelected(item)"
          (click)="item.type === 'folder' ? navigateInto(item) : toggleItem(item)"
        >
          <nb-icon
            [icon]="item.type === 'folder' ? 'folder-outline' : 'file-text-outline'"
            [status]="isSelected(item) ? 'primary' : 'basic'"
          ></nb-icon>
          <span class="item-name">{{ item.name }}</span>
          <nb-icon *ngIf="item.type === 'folder'" icon="chevron-right-outline" class="folder-arrow"></nb-icon>
          <nb-checkbox
            *ngIf="item.type === 'file'"
            [checked]="isSelected(item)"
            (checkedChange)="toggleItem(item)"
            (click)="$event.stopPropagation()"
          ></nb-checkbox>
        </div>
        <p *ngIf="browseItems.length === 0" class="empty-state">
          {{ "dialogs.cloudSync.emptyFolder" | translate }}
        </p>
      </div>

      <!-- Sync frequency -->
      <div class="sync-frequency" *ngIf="!loadingItems">
        <label class="label">{{ "dialogs.cloudSync.syncFrequency" | translate }}</label>
        <nb-select [(selected)]="syncFrequency" size="small">
          <nb-option value="never">{{ "enums.syncFrequency.never" | translate }}</nb-option>
          <nb-option value="daily">{{ "enums.syncFrequency.daily" | translate }}</nb-option>
          <nb-option value="monthly">{{ "enums.syncFrequency.monthly" | translate }}</nb-option>
        </nb-select>
      </div>
    </ng-container>

  </nb-card-body>

  <nb-card-footer>
    <button nbButton status="danger" outline (click)="close()">
      {{ "buttons.close" | translate }}
    </button>
    <button *ngIf="step === 'browse'" nbButton appearance="outline" (click)="backToProviders()">
      {{ "buttons.back" | translate }}
    </button>
    <button
      *ngIf="step === 'browse'"
      nbButton
      status="primary"
      [disabled]="selectedCount === 0 || importing"
      [nbSpinner]="importing"
      (click)="onImport()"
    >
      {{ "dialogs.cloudSync.import" | translate }} ({{ selectedCount }})
    </button>
  </nb-card-footer>
</nb-card>
